import { SimState, ENERGY_REGEN } from './types';

export const EnergySystem = {
  tick(state: SimState, dt: number) {
    const r = state.res;
    if (r.energy < r.maxEnergy) {
      r.energy = Math.min(r.maxEnergy, r.energy + ENERGY_REGEN * dt);
    }
  },

  has(state: SimState, cost: number): boolean {
    return state.res.energy >= cost;
  },

  spend(state: SimState, cost: number): boolean {
    if (state.res.energy < cost) return false;
    state.res.energy -= cost;
    return true;
  },

  refill(state: SimState) {
    state.res.energy = state.res.maxEnergy;
  },
};
